/** Only recognise the exact case route for this notification's application. */
export function visaNotificationRoute(
  data: { applicationId?: unknown; url?: unknown },
  admin = false,
): string | null {
  const id = String(data.applicationId || "");
  if (!/^[1-9]\d*$/.test(id)) return null;
  if (!admin)
    return data.url === `/applications/${id}/visa-support`
      ? `/applications/${id}/visa-support`
      : null;
  return data.url === `/agent-student-applications/${id}?tab=visa-support`
    ? `/admin/agent-student-applications/${id}?tab=visa-support#visa-support`
    : null;
}
